export default "__VITE_ASSET__BSxuB0Ru__"